import { c as _c } from "react/compiler-runtime";
export default function SearchResultIcon(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="flex w-12 shrink-0 justify-center [&>svg]:relative [&>svg]:-left-1">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}